// Discovery view init (Phase 5D slice 2).

export function init(..._args: Array<string>): void {
	document.body.classList.add('lb-redesign-body');
	if (document.getElementById('id_lb-deal-discover')) {
		import('./view')
			.then(mod => (new mod.DealDiscoveryView()));
	}
}
